import { MutationUpdaterFn } from '@apollo/client'

export const update: MutationUpdaterFn = (cache) => {
	cache.reset()
}

export const onError = (err: Error) => console.error(err)